import React from "react";
import RoleForm from './RoleForm';

const AddNewRole = () => <RoleForm />;

export default AddNewRole;
